function SvgPlay() {
  return (
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8 5L1 1V9L8 5Z" fill="#FBFBFB" stroke="#FBFBFB"/>
</svg>
  )
}


export default SvgPlay;